import React, { useEffect, useState, useContext } from "react";
import { PatientContext, UserContext } from "../../lib/main-context";
import { useTranslation } from "../../i18n/TranslationProvider";

import { Form } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers";
import goalSchema from "./validations/goalSchema";

import LabelledInput from "../UIComponents/LabelledInput";
import SubmitButton from "../UIComponents/SubmitButton";

import { updateGoals, getGoals } from "../../api/TBIRequests";

const SettingGoals = ({ setIsSuccess }) => {
  const { user } = useContext(UserContext);
  const { patient } = useContext(PatientContext);
  const { t } = useTranslation();

  const [submitting, setSubmitting] = useState(false);
  const { errors, handleSubmit, register, setValue } = useForm({
    resolver: yupResolver(goalSchema),
  });

  useEffect(() => {
    setIsSuccess(undefined);
    getGoals({
      patientId: patient.patientId,
      therapistId: user.userType === "Therapist" ? user.userId : null,
    }).then((result) => {
      setValue("firstGoal", result.data[0].first_goal);
      setValue("secondGoal", result.data[0].second_goal);
      setValue("thirdGoal", result.data[0].third_goal);
    });
  }, []);

  const onSubmit = (data) => {
    setSubmitting(true);
    updateGoals({
      patientId: patient.patientId,
      therapistId: user.userType === "Therapist" ? user.userId : null,
      data,
    })
      .then(() => {
        setIsSuccess(true);
        setSubmitting(false);
      })
      .catch((err) => {
        console.log(err);
        setIsSuccess(false);
        setSubmitting(false);
      });
  };

  return (
    <Form className="goalForm" onSubmit={handleSubmit(onSubmit)}>
      <Form.Label as="h6" style={{ width: "100%" }}>
        {t("settinggoals.label")}
      </Form.Label>
      <LabelledInput
        name="firstGoal"
        label={t("settinggoals.first_goal")}
        errors={errors}
        inputRef={register}
        autoFocus
      />
      <LabelledInput
        name="secondGoal"
        label={t("settinggoals.second_goal")}
        errors={errors}
        inputRef={register}
      />
      <LabelledInput
        name="thirdGoal"
        label={t("settinggoals.third_goal")}
        errors={errors}
        inputRef={register}
      />
      <SubmitButton disabled={submitting} type="submit">
        {t("settinggoals.save")}
      </SubmitButton>
    </Form>
  );
};

export default SettingGoals;